/** Words shared by many areas: common actions and the language names. */
export default {
  cancel: "Cancel",
  save: "Save",
  close: "Close",
  done: "Done",
  continue: "Continue",
  back: "Back",
  retry: "Try again",
  delete: "Delete",
  remove: "Remove",
  edit: "Edit",
  copy: "Copy",
  copied: "Copied",
  open: "Open",
  skip: "Skip",
  loading: "Loading…",
  on: "On",
  off: "Off",
  yes: "Yes",
  no: "No",
  language: "Language",
  somethingWentWrong: "Something went wrong.",
  somethingWentWrongRetry: "Something went wrong. Please try again.",
  images: "Images",
  filesNotOpened: {
    one: "Couldn’t open {count} file",
    other: "Couldn’t open {count} files",
  },
  filesNotOpenedHint: "Files need to be readable and 20 MB or smaller.",
  items: { one: "{count} item", other: "{count} items" },
} as const;
